import React from 'react';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export default function LayoutSection(props) {
  var _props$content;
  return editorExperiment('advanced_layouts', true) ?
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  React.createElement("div", {
    className: "layout-section-container",
    "data-local-id": props.localId
  }, /*#__PURE__*/React.createElement("div", {
    "data-layout-section": true,
    "data-layout-columns": props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
  }, props.children)) : /*#__PURE__*/React.createElement("div", {
    "data-layout-section": true,
    "data-local-id": props.localId
  }, props.children);
}